import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.materials.detail');
import { OnInit, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface DetailField {
    label: string;
    value: any;
    source: string;
    editable: boolean;
    field: string;
}

interface StatusMaterial {
    id: string;
    title: string;
    materialType: string;
    contributor: string;
    reviewStatus: string;
    publicStatus: string;
    originalDbStatus: string;
    metadataStatus: string;
    registrationMethod: string;
    sourceType: string;
    lastModified: string;
    publicDetailUrl: string;
    adminEditApplied: boolean;
    verificationStatus?: any;
}

interface MaterialDetailForm {
    materialId: string;
    title: string;
    materialType: string;
    contributor: string;
    publisher: string;
    publishedYear: string;
    publicationInfo: string;
    source: string;
    seriesTitle: string;
    externalIdentifier: string;
    classification: string;
    subjectKeywords: string;
    summary: string;
    publicStatus: string;
    reviewStatus: string;
    rightsNote: string;
    reviewNote: string;
    confirmedKdc: string;
    confirmedAuthority: string;
    confirmedMarc: string;
    confirmedSubjectKeywords: string;
    summaryConfirmed: string;
    bodyIndexConfirmed: string;
    evidenceNote: string;
    changeNote?: string;
}

@Component({
    selector: 'wiz-page-admin-materials-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.materials.detail/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
}

.material-detail-page {
  width: min(1320px, 100% - 48px);
  min-height: 100vh;
  margin: 0 auto;
  padding: 20px 0 36px;
  background: var(--design-bg);
  color: var(--design-text);
  font-family: SUIT, Arial, sans-serif;
}

.detail-header,
.access-summary,
.status-hero,
.effect-panel,
.detail-panel,
.save-bar {
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: var(--admin-panel-bg);
  box-shadow: var(--design-shadow);
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
}

.detail-title {
  min-width: 0;
}

.detail-title p,
.detail-title h1,
.detail-title span,
.status-title h2,
.status-title p,
.effect-panel h2,
.effect-panel p,
.panel-heading p,
.panel-heading h2 {
  margin: 0;
}

.detail-title p,
.detail-title span,
.panel-heading p,
.panel-heading > span,
.access-summary span,
.access-summary p,
.effect-panel p,
.effect-grid span,
.field-grid span,
.field-grid em,
.wide-note span,
.wide-note em,
.state-edit-grid span,
.state-edit-grid em {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 800;
}

.detail-title h1 {
  margin-top: 6px;
  font-size: 23px;
  font-weight: 850;
  line-height: 1.25;
  letter-spacing: 0;
}

.detail-title span {
  display: block;
  margin-top: 7px;
  line-height: 1.45;
}

.detail-header nav {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.detail-header a,
.denied-panel a {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 11px;
  background: #ffffff;
  color: var(--design-accent);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.detail-header a:hover,
.detail-header a:focus-visible,
.denied-panel a:hover,
.denied-panel a:focus-visible {
  border-color: var(--design-border-strong);
  background: var(--admin-button-secondary-hover);
  box-shadow: var(--design-focus-ring);
}

.detail-header a[href="/admin/materials/new"],
.denied-panel a {
  border-color: var(--admin-button-primary-bg);
  background: var(--admin-button-primary-bg);
  color: var(--design-on-accent);
}

.detail-header a[href="/admin/materials/new"]:hover,
.detail-header a[href="/admin/materials/new"]:focus-visible,
.denied-panel a:hover,
.denied-panel a:focus-visible {
  border-color: var(--admin-button-primary-hover);
  background: var(--admin-button-primary-hover);
}

.access-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 12px 0;
  padding: 12px 16px;
}

.access-summary div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.access-summary strong {
  font-size: 14px;
  font-weight: 850;
}

.status-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-top: 12px;
  padding: 18px 20px;
}

.status-title {
  min-width: 0;
}

.status-title span {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 850;
}

.status-title h2 {
  margin-top: 7px;
  font-size: 24px;
  font-weight: 850;
  line-height: 1.28;
  overflow-wrap: break-word;
}

.status-title p {
  margin-top: 8px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 750;
}

.status-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  max-width: 520px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  border: 1px solid var(--design-border-soft);
  border-radius: 999px;
  padding: 0 9px;
  background: #ffffff;
  color: var(--design-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
  white-space: nowrap;
}

.status-badge.is-pending {
  background: var(--admin-badge-hold-bg);
  color: var(--admin-badge-hold-text);
}

.status-badge.is-muted {
  background: #f7f7f7;
  color: var(--design-text-secondary);
}

.status-badge.is-public {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.status-badge.is-complete {
  background: var(--admin-badge-complete-bg);
  color: var(--admin-badge-complete-text);
}

.status-badge.is-internal {
  background: var(--admin-badge-internal-bg);
  color: var(--admin-badge-internal-text);
}

.status-badge.is-hold,
.status-badge.is-review-pending,
.status-badge.is-draft {
  border-color: rgba(138, 90, 0, 0.2);
  background: var(--admin-badge-hold-bg);
  color: var(--admin-badge-hold-text);
}

.status-badge.is-private {
  background: var(--admin-badge-private-bg);
  color: var(--admin-badge-private-text);
}

.status-badge.is-review-complete {
  border-color: rgba(8, 116, 67, 0.18);
  background: var(--admin-badge-public-bg);
  color: var(--admin-badge-public-text);
}

.effect-panel {
  display: grid;
  grid-template-columns: minmax(260px, 0.5fr) minmax(0, 1fr);
  gap: 16px;
  margin-top: 12px;
  padding: 18px;
}

.effect-panel h2 {
  font-size: 17px;
  font-weight: 850;
}

.effect-panel p {
  margin-top: 6px;
  line-height: 1.45;
}

.effect-panel .review-principle {
  color: var(--design-info);
}

.effect-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.effect-grid article {
  min-width: 0;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px;
  background: var(--design-bg-muted);
}

.effect-grid strong {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 850;
}

.effect-grid span {
  display: inline-flex;
  margin: 0 5px 6px 0;
  border: 1px solid var(--design-border-soft);
  border-radius: 999px;
  padding: 4px 7px;
  background: #ffffff;
}

.detail-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
}

.detail-tabs button {
  min-height: 38px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 0 13px;
  background: #ffffff;
  color: var(--design-text-secondary);
  cursor: pointer;
  font-size: 13px;
  font-weight: 850;
}

.detail-tabs button.active {
  border-color: var(--design-accent);
  background: var(--design-accent);
  color: var(--design-on-accent);
}

.detail-tabs button:focus-visible {
  outline: 3px solid rgba(23, 74, 120, 0.3);
  outline-offset: 2px;
}

.detail-panel:focus-visible {
  outline: 3px solid rgba(23, 74, 120, 0.22);
  outline-offset: 2px;
}

.detail-tabs button:not(.active):hover,
.detail-tabs button:not(.active):focus-visible {
  border-color: var(--design-border-strong);
  background: var(--admin-button-secondary-hover);
  box-shadow: var(--design-focus-ring);
}

.detail-panel {
  margin-top: 12px;
  padding: 16px;
}

.panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.panel-heading h2 {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 850;
  line-height: 1.3;
}

.panel-heading > span {
  white-space: nowrap;
}

.field-grid,
.state-edit-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.metadata-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.field-grid label,
.wide-note,
.state-edit-grid label,
.save-bar label {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.field-grid label,
.state-edit-grid label {
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 10px 12px;
  background: #ffffff;
}

.field-grid label.readonly {
  background: var(--design-bg-muted);
}

.field-grid input,
.field-grid select,
.field-grid textarea,
.state-edit-grid select,
.state-edit-grid textarea,
.wide-note textarea,
.save-bar input {
  width: 100%;
  min-height: 38px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 8px 10px;
  background: #ffffff;
  color: var(--design-body-text);
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
  outline: none;
}

.field-grid textarea,
.state-edit-grid textarea,
.wide-note textarea {
  resize: vertical;
}

.field-grid input:focus,
.field-grid select:focus,
.field-grid textarea:focus,
.state-edit-grid select:focus,
.state-edit-grid textarea:focus,
.wide-note textarea:focus,
.save-bar input:focus {
  border-color: var(--design-focus-ring-color);
  box-shadow: var(--design-focus-ring);
}

.field-grid output {
  min-height: 38px;
  display: block;
  border: 1px solid transparent;
  padding: 8px 0;
  color: var(--design-body-text);
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.field-grid em,
.wide-note em,
.state-edit-grid em {
  font-style: normal;
}

.field-grid em.is-ai,
.tag-list em.is-ai {
  color: var(--design-pending-text);
}

.field-grid em.is-confirmed,
.tag-list em.is-confirmed {
  color: var(--design-info);
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}

.summary-grid article {
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 13px;
  background: var(--design-bg-muted);
}

.summary-grid span,
.summary-grid em {
  display: block;
  color: var(--design-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.summary-grid strong {
  display: block;
  margin: 7px 0;
  font-size: 22px;
  font-weight: 850;
}

.table-scroll {
  overflow-x: auto;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
}

.detail-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  table-layout: fixed;
}

.detail-table th,
.detail-table td {
  border-top: 1px solid var(--design-border-soft);
  padding: 12px 10px;
  color: var(--design-body-text);
  font-size: 13px;
  line-height: 1.45;
  text-align: left;
  vertical-align: top;
  overflow-wrap: break-word;
}

.detail-table th {
  background: var(--design-bg-muted);
  color: var(--design-text-secondary);
  font-weight: 850;
}

.tag-list,
.chunk-list,
.history-list {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}

.tag-list article,
.chunk-list article,
.history-list article,
.graph-grid article {
  min-width: 0;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px;
  background: var(--design-bg-muted);
}

.tag-list strong,
.chunk-list strong,
.history-list strong,
.graph-grid strong {
  display: block;
  color: var(--design-text);
  font-size: 14px;
  font-weight: 850;
  line-height: 1.35;
  overflow-wrap: break-word;
}

.tag-list span,
.chunk-list span,
.history-list span,
.graph-grid span,
.graph-grid em,
.chunk-list em,
.history-list em {
  display: block;
  margin-top: 4px;
  color: var(--design-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.4;
}

.chunk-list p,
.history-list p,
.graph-grid p {
  margin: 8px 0 0;
  color: var(--design-body-text);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
  overflow-wrap: break-word;
}

.wide-note {
  margin-top: 14px;
}

.graph-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.graph-grid section {
  min-width: 0;
}

.graph-grid h3 {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 850;
}

.graph-grid article + article {
  margin-top: 8px;
}

.graph-grid article.is-selected {
  border-color: var(--design-accent);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--design-accent) 18%, transparent);
}

.relation-select-button,
.relation-swap-button,
.relation-save-button {
  min-height: 36px;
  border: 1px solid var(--design-accent);
  border-radius: 7px;
  padding: 7px 11px;
  background: #ffffff;
  color: var(--design-accent);
  cursor: pointer;
  font-weight: 850;
}

.relation-history {
  display: grid;
  gap: 8px;
  margin: 0 0 14px;
}

.relation-history article {
  border-left: 3px solid var(--design-accent);
  padding: 8px 10px;
  background: #ffffff;
}

.relation-history span,
.relation-history p {
  display: block;
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}

.relation-select-button {
  margin-top: 10px;
}

.relation-editor {
  margin-top: 16px;
  border: 1px solid var(--design-border);
  border-radius: 10px;
  padding: 16px;
  background: var(--design-bg-muted);
}

.relation-editor-heading {
  margin-bottom: 12px;
}

.relation-editor-heading h3 {
  margin: 4px 0 0;
}

.relation-evidence-contract {
  display: grid;
  gap: 8px;
  margin: 14px 0;
}

.relation-evidence-contract div {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 10px;
}

.relation-evidence-contract dt,
.relation-evidence-contract dd {
  margin: 0;
  line-height: 1.5;
}

.relation-evidence-contract dt {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 850;
}

.relation-evidence-contract dd {
  overflow-wrap: anywhere;
  font-size: 13px;
}

.relation-save-button {
  background: var(--design-accent);
  color: var(--design-on-accent);
}

.relation-select-button:disabled,
.relation-swap-button:disabled,
.relation-save-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.save-bar {
  position: sticky;
  bottom: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: end;
  margin-top: 14px;
  padding: 14px;
}

.save-bar span {
  color: var(--design-text-secondary);
  font-size: 12px;
  font-weight: 850;
}

.save-bar button {
  min-height: 40px;
  border: 1px solid var(--design-accent);
  border-radius: 8px;
  padding: 0 18px;
  background: var(--design-accent);
  color: var(--design-on-accent);
  cursor: pointer;
  font-size: 13px;
  font-weight: 850;
}

.save-bar button:hover,
.save-bar button:focus-visible {
  border-color: var(--admin-button-primary-hover);
  background: var(--admin-button-primary-hover);
  box-shadow: var(--design-focus-ring);
}

.save-bar button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.notice {
  margin: 14px 0 0;
  font-size: 13px;
  font-weight: 850;
}

.notice.error {
  color: #9a2a2a;
}

.notice.success {
  color: var(--design-info);
}

.notice.warning {
  border-color: #d5b66a;
  background: #fff9e8;
  color: #6f520d;
}

.empty-guidance {
  display: grid;
  gap: 10px;
  margin-top: 14px;
  border: 1px solid var(--design-border-soft);
  border-radius: 10px;
  padding: 20px;
  background: #ffffff;
}

.empty-guidance h2,
.empty-guidance p {
  margin: 0;
}

.empty-guidance div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.empty-guidance a {
  border: 1px solid var(--design-border-strong);
  border-radius: 7px;
  padding: 8px 11px;
  color: var(--design-text);
  font-weight: 800;
  text-decoration: none;
}

.empty-cell {
  color: var(--design-text-secondary);
  text-align: center;
}

.denied-page {
  display: grid;
  place-items: center;
}

.denied-panel {
  width: min(420px, 100%);
  border: 1px solid var(--design-border);
  border-radius: 8px;
  padding: 24px;
  background: #ffffff;
  box-shadow: var(--design-shadow);
  text-align: center;
}

.denied-panel p,
.denied-panel h1 {
  margin: 0;
}

.denied-panel p {
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 850;
}

.denied-panel h1 {
  margin-top: 8px;
  font-size: 22px;
  font-weight: 850;
}

.denied-panel a {
  margin-top: 18px;
}

.count-definition {
  margin-top: 14px;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px;
  background: var(--design-bg-muted);
}

.count-definition summary {
  cursor: pointer;
  font-weight: 850;
}

.count-definition p,
.count-definition li {
  margin-top: 7px;
  color: var(--design-text-secondary);
  font-size: 12px;
  line-height: 1.5;
}

@media (max-width: 1100px) {
  .effect-panel,
  .effect-grid,
  .graph-grid {
    grid-template-columns: 1fr;
  }
  .field-grid,
  .metadata-grid,
  .state-edit-grid,
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .material-detail-page {
    width: min(100% - 28px, 1360px);
    padding-top: 14px;
  }
  .detail-header,
  .access-summary,
  .status-hero,
  .panel-heading,
  .save-bar {
    align-items: flex-start;
    grid-template-columns: 1fr;
    flex-direction: column;
  }
  .status-badges {
    justify-content: flex-start;
  }
  .field-grid,
  .metadata-grid,
  .state-edit-grid,
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .panel-heading > span {
    white-space: normal;
  }
}
/* Review 157 common UI */
:host {
  background: #FFFFFF;
  color: #333333;
  font-size: 16px;
  line-height: 1.6;
}

:host h1,
:host h2,
:host h3,
:host strong {
  font-weight: 700;
}

:host p,
:host span,
:host label,
:host input,
:host select,
:host textarea,
:host button,
:host a,
:host th,
:host td,
:host small,
:host em {
  font-size: max(15px, 1em);
}

:host p,
:host span,
:host td,
:host small,
:host em {
  font-weight: 400;
}

:host label,
:host th,
:host button {
  font-weight: 600;
}

:host input,
:host select,
:host textarea {
  border-color: #D8D8D8;
  background: #FFFFFF;
  color: #333333;
}

:host input:focus,
:host select:focus,
:host textarea:focus {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 3px rgba(43, 43, 43, 0.16);
  outline: none;
}

:host button:disabled,
:host input:disabled,
:host select:disabled,
:host textarea:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

:host .table-scroll {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
}

:host table th,
:host table td {
  word-break: normal;
  overflow-wrap: break-word;
}

:host table th:first-child,
:host table td:first-child,
:host table th:last-child,
:host table td:last-child {
  white-space: nowrap;
}

:host .status-badge {
  font-size: 13px;
  font-weight: 600;
  word-break: keep-all;
  white-space: normal;
}

:host .notice,
:host .empty-cell,
:host .denied-panel {
  border-color: #D8D8D8;
  background: #F5F5F5;
}

:host .field-error {
  display: block;
  margin-top: 6px;
  color: #9A2A2A;
  font-size: 14px;
  font-weight: 600;
}

.material-detail-page {
  background: #FFFFFF;
}

.detail-header,
.access-summary,
.material-summary,
.detail-tabs,
.detail-panel,
.save-bar {
  background: #FFFFFF;
  box-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
}

.access-summary,
.save-policy,
.summary-grid {
  background: #F5F5F5;
}

.detail-tabs button.active,
.save-bar button {
  border-color: #2B2B2B;
  background: #2B2B2B;
  color: #FFFFFF;
}

.detail-tabs button:not(.active),
.detail-header nav a:not(.primary-link) {
  border-color: #BDBDBD;
  background: #FFFFFF;
  color: #2B2B2B;
}

.detail-table {
  min-width: 1120px;
}

.detail-table th:nth-child(2),
.detail-table td:nth-child(2) {
  min-width: 230px;
}

.detail-table th:last-child,
.detail-table td:last-child {
  min-width: 96px;
}

.material-detail-page p,
.material-detail-page span,
.material-detail-page a,
.material-detail-page label,
.material-detail-page input,
.material-detail-page select,
.material-detail-page textarea,
.material-detail-page td,
.material-detail-page small,
.material-detail-page em {
  font-size: 15px;
  font-weight: 400;
}

.material-detail-page h1,
.material-detail-page h2,
.material-detail-page h3,
.material-detail-page strong {
  font-weight: 700;
}

.material-detail-page button,
.material-detail-page label,
.material-detail-page th,
.material-detail-page .field-label {
  font-size: 15px;
  font-weight: 600;
}

.material-detail-page .status-badge {
  font-size: 13px;
  font-weight: 600;
}

/* 159단계: 안전한 부분 편집과 원천/후보 비교 */
.field-grid textarea {
  width: 100%;
  min-height: 84px;
  resize: vertical;
}

.source-comparison {
  margin-top: 18px;
  border-top: 1px solid #D8D8D8;
  padding-top: 18px;
}

.source-comparison h3,
.source-comparison p {
  margin: 0;
}

.source-comparison p {
  margin-top: 6px;
  color: #5E5E5E;
}

.comparison-table {
  width: 100%;
  min-width: 920px;
  margin-top: 14px;
  border-collapse: collapse;
}

.comparison-table th,
.comparison-table td {
  border-bottom: 1px solid #E4E4E4;
  padding: 11px;
  text-align: left;
  vertical-align: top;
  white-space: pre-line;
}

.comparison-table th:first-child {
  min-width: 130px;
}

.comparison-table button,
.tag-list button {
  min-height: 34px;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  padding: 0 10px;
  background: #FFFFFF;
  color: #2B2B2B;
}

.detail-table {
  min-width: 980px;
}

.detail-table td:first-child strong,
.detail-table td:first-child small {
  display: block;
}

.detail-table td:first-child small {
  margin-top: 5px;
  color: #6A6A6A;
}

.file-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.file-actions a {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  padding: 0 8px;
  color: #2B2B2B;
  text-decoration: none;
}

.save-bar {
  position: sticky;
  bottom: 8px;
  z-index: 4;
  grid-template-columns: minmax(240px, 1fr) auto auto auto;
}

.unsaved-indicator {
  color: #5E5E5E;
  white-space: nowrap;
}

.unsaved-indicator.active {
  color: #8A5A00;
  font-weight: 700;
}

.save-bar .cancel-button {
  border: 1px solid #BDBDBD;
  background: #FFFFFF;
  color: #2B2B2B;
}

@media (max-width: 720px) {
  .material-detail-page {
    width: min(100% - 20px, 1320px);
    padding-top: 10px;
  }
  .detail-header,
  .status-hero,
  .access-summary,
  .effect-panel {
    display: block;
  }
  .detail-header nav,
  .status-badges {
    justify-content: flex-start;
    margin-top: 14px;
  }
  .detail-header nav a,
  .file-actions a {
    min-height: 42px;
  }
  .save-bar {
    position: static;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .save-bar label,
  .save-bar .unsaved-indicator {
    grid-column: 1/-1;
  }
  .save-bar button {
    width: 100%;
    min-height: 44px;
  }
}
/* 160단계: 사유별 자료 확인과 공개 승인 분리 */
.review-panel {
  display: grid;
  gap: 18px;
}

.review-panel .review-principle {
  margin: -6px 0 0;
  color: #2B2B2B;
}

.review-reason-nav {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.review-reason-nav button {
  min-width: 0;
  display: grid;
  gap: 4px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 12px;
  background: #FFFFFF;
  color: #333333;
  text-align: left;
}

.review-reason-nav button.active {
  border-color: #2B2B2B;
  box-shadow: 0 0 0 2px rgba(43, 43, 43, 0.12);
}

.review-reason-nav span,
.review-reason-nav em,
.review-context p,
.review-context span,
.review-material-grid span,
.review-material-grid em,
.review-evidence-grid span,
.review-evidence-grid em,
.review-file-list span,
.review-file-list em {
  color: #5E5E5E;
  font-style: normal;
}

.review-reason-nav strong,
.review-reason-nav em {
  overflow-wrap: anywhere;
}

.review-context {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-left: 4px solid #2B2B2B;
  padding: 4px 0 4px 14px;
}

.review-context p,
.review-context h3,
.review-context span,
.review-material-grid span,
.review-material-grid strong,
.review-material-grid em,
.review-evidence-grid span,
.review-evidence-grid strong,
.review-evidence-grid em {
  display: block;
  margin: 0;
}

.review-material-grid,
.review-evidence-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.review-evidence-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.review-material-grid article,
.review-evidence-grid article,
.review-file-list article,
.publication-range article,
.publication-range label {
  min-width: 0;
  display: grid;
  gap: 5px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 12px;
  background: #FFFFFF;
}

.review-evidence-grid a,
.review-file-list a {
  width: fit-content;
  margin-top: 4px;
  color: #2B2B2B;
  font-weight: 600;
}

.review-file-list {
  display: grid;
  gap: 8px;
}

.review-file-list h3,
.review-check-groups h3,
.publication-decision h3,
.reason-history h3 {
  margin: 0;
}

.review-file-list article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.review-file-list article div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.review-check-groups {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.review-check-groups > section {
  display: grid;
  align-content: start;
  gap: 8px;
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 14px;
}

.review-check-groups article,
.review-check-groups label {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  border-top: 1px solid #E4E4E4;
  padding-top: 10px;
}

.review-check-groups article div,
.review-check-groups label span {
  display: grid;
  gap: 3px;
}

.review-check-groups label input {
  width: 18px;
  height: 18px;
  margin: 3px 0 0;
}

.review-check-groups label em {
  color: #5E5E5E;
  font-style: normal;
}

.check-state {
  border-radius: 999px;
  padding: 3px 7px;
  background: #F5F5F5;
  color: #5E5E5E;
  font-style: normal;
  white-space: nowrap;
}

.check-state.is-met {
  background: #EAF5EE;
  color: #087443;
}

.check-state.is-unmet {
  background: #FFF3DB;
  color: #8A5A00;
}

.publication-decision,
.review-action-box,
.reason-history,
.review-policy-tables {
  border: 1px solid #D8D8D8;
  border-radius: 8px;
  padding: 14px;
  background: #F5F5F5;
}

.publication-decision p,
.review-action-box p {
  margin: 6px 0 0;
  color: #5E5E5E;
}

.publication-range {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  margin-top: 12px;
}

.publication-range label select {
  width: 100%;
}

.publication-decision ul {
  margin: 12px 0 0;
  padding-left: 22px;
}

.review-action-box label {
  display: grid;
  gap: 6px;
}

.review-action-box textarea {
  width: 100%;
  resize: vertical;
}

.review-action-box > div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.review-action-box button {
  min-height: 40px;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  padding: 0 12px;
  background: #FFFFFF;
  color: #2B2B2B;
}

.review-action-box button.primary-action {
  border-color: #2B2B2B;
  background: #2B2B2B;
  color: #FFFFFF;
}

.reason-history {
  display: grid;
  gap: 8px;
}

.reason-history article {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 6px 12px;
  border-top: 1px solid #D8D8D8;
  padding-top: 10px;
}

.reason-history article p {
  grid-column: 1/-1;
  margin: 0;
  white-space: pre-line;
}

.reason-history article em {
  font-style: normal;
}

.review-policy-tables summary {
  cursor: pointer;
  font-weight: 700;
}

.review-policy-tables h3 {
  margin: 16px 0 8px;
}

.review-policy-tables table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  background: #FFFFFF;
}

.review-policy-tables th,
.review-policy-tables td {
  border-bottom: 1px solid #E4E4E4;
  padding: 10px;
  text-align: left;
  vertical-align: top;
}

@media (max-width: 960px) {
  .review-reason-nav,
  .review-material-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .review-evidence-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 720px) {
  .review-reason-nav,
  .review-material-grid,
  .review-check-groups,
  .publication-range {
    grid-template-columns: 1fr;
  }
  .review-context,
  .review-file-list article {
    display: grid;
  }
  .publication-range > span {
    transform: rotate(90deg);
    justify-self: center;
  }
  .reason-history article {
    grid-template-columns: 1fr;
  }
  .reason-history article p {
    grid-column: 1;
  }
}`],
})
export class PageAdminMaterialsDetailComponent implements OnInit {
    public accessDenied: boolean = false;
    public loading: boolean = false;
    public saving: boolean = false;
    public reviewSaving: boolean = false;
    public relationSaving: boolean = false;
    public errorMessage: string = "";
    public message: string = "";
    public routeNotice: string = "";
    public notFound: boolean = false;
    public activeTab: string = "bibliography";
    public materialId: string = "";
    public material: StatusMaterial | null = null;
    public form: MaterialDetailForm = this.emptyForm();
    public sections: any = {};
    public options: any = { materialTypes: [], accessLevels: [], reviewStatuses: [] };
    public savePolicy: any = { immediateFields: [], reviewPendingFields: [] };
    public publicApprovalPolicy: string = "공개 상태는 공개 승인 권한 보유 계정만 변경할 수 있습니다.";
    public baseVersion: string = "";
    public selectedReviewReason: string = "";
    public reviewForm: any = { note: "", targetPublicStatus: "", confirmations: {} };
    public selectedGraphRelation: any = null;
    public relationForm: any = { relationType: "", reviewStatus: "검수 대기", reviewNote: "", swapDirection: false };
    private reviewRequestId: string = "";
    public tabs: any[] = [
        { key: "review", label: "자료 확인" },
        { key: "bibliography", label: "기본정보" },
        { key: "original", label: "원문 파일" },
        { key: "metadata", label: "자료 정보·후보" },
        { key: "chunks", label: "본문 검색" },
        { key: "graph", label: "자료 관계" },
        { key: "history", label: "변경 기록" },
    ];
    private cleanFormSnapshot: string = "";
    private cleanForm: MaterialDetailForm = this.emptyForm();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.canAccessMaterials()) {
            this.accessDenied = true;
            await this.service.render();
            return;
        }
        this.materialId = this.routeMaterialId();
        if (!this.materialId) {
            this.notFound = true;
            this.errorMessage = "자료ID가 없어 상세 정보를 열 수 없습니다.";
            await this.service.render();
            return;
        }
        this.restoreTabFromUrl(true);
        await this.loadDetail();
    }

    public emptyForm(): MaterialDetailForm {
        return {
            materialId: "",
            title: "",
            materialType: "",
            contributor: "",
            publisher: "",
            publishedYear: "",
            publicationInfo: "",
            source: "",
            seriesTitle: "",
            externalIdentifier: "",
            classification: "",
            subjectKeywords: "",
            summary: "",
            publicStatus: "",
            reviewStatus: "",
            rightsNote: "",
            reviewNote: "",
            confirmedKdc: "",
            confirmedAuthority: "",
            confirmedMarc: "",
            confirmedSubjectKeywords: "",
            summaryConfirmed: "",
            bodyIndexConfirmed: "",
            evidenceNote: "",
            changeNote: "",
        };
    }

    public routeMaterialId(): string {
        let fromRoute = this.text((window as any).WizRoute?.segment?.materialId);
        if (fromRoute) return decodeURIComponent(fromRoute);
        let parts = (window.location.pathname || "").split("/").filter((item) => !!item);
        return decodeURIComponent(parts[parts.length - 1] || "");
    }

    public async loadDetail() {
        this.loading = true;
        this.errorMessage = "";
        this.notFound = false;
        await this.service.render();
        let response: any = await wiz.call("detail", { materialId: this.materialId });
        this.loading = false;
        if (response.code === 403) {
            this.accessDenied = true;
            this.errorMessage = this.responseMessage(response, "접근 권한이 없습니다.");
            await this.service.render();
            return;
        }
        if (response.code !== 200) {
            this.notFound = response.code === 404;
            this.errorMessage = this.responseMessage(
                response,
                this.notFound ? `자료ID ${this.materialId}에 해당하는 자료를 찾을 수 없습니다.` : "자료 상세 정보를 불러오지 못했습니다."
            );
            await this.service.render();
            return;
        }
        this.material = response.data?.material || null;
        this.form = { ...this.emptyForm(), ...(response.data?.form || {}) };
        this.baseVersion = this.text(response.data?.baseVersion);
        this.sections = response.data?.sections || {};
        this.options = response.data?.options || this.options;
        this.savePolicy = response.data?.savePolicy || this.savePolicy;
        this.publicApprovalPolicy = response.data?.publicApprovalPolicy || this.publicApprovalPolicy;
        this.restoreReviewReasonFromUrl();
        this.resetReviewForm();
        if (this.selectedGraphRelation?.id) {
            let selectedId = this.selectedGraphRelation.id;
            this.selectedGraphRelation = (this.sections?.graph?.relations || []).find((row: any) => row.id === selectedId) || null;
            if (this.selectedGraphRelation) this.resetRelationForm();
        }
        this.markFormClean();
        await this.service.render();
    }

    public async save() {
        if (this.saving) return;
        this.errorMessage = "";
        this.message = "";
        if (!this.canEditMaterials() && !this.canApprovePublication()) {
            this.errorMessage = "자료 수정 권한이 없습니다.";
            await this.service.render();
            return;
        }
        let changes = this.changedFields();
        if (Object.keys(changes).length === 0) {
            this.errorMessage = "저장할 변경 항목이 없습니다.";
            await this.service.render();
            return;
        }
        let missing = this.requiredMissing();
        if (missing.length > 0) {
            this.errorMessage = `필수 입력값을 확인해주세요: ${missing.join(", ")}`;
            await this.service.render();
            return;
        }
        this.saving = true;
        await this.service.render();
        let response: any;
        try {
            response = await wiz.call("save", {
                payload: JSON.stringify({
                    materialId: this.form.materialId,
                    baseVersion: this.baseVersion,
                    changes,
                    changeNote: this.form.changeNote || "",
                })
            });
        } catch (e) {
            this.saving = false;
            let error: any = e as any;
            let code = Number(error?.code || error?.status || error?.response?.status || 0);
            let serialized = "";
            try { serialized = JSON.stringify(error || {}); } catch (ignore) { }
            this.errorMessage = code === 409 || serialized.includes("409")
                ? "다른 사용자가 먼저 저장했습니다. 입력값은 유지됩니다. 새로고침 후 최신 값과 다시 비교해주세요."
                : "서버 저장에 실패했습니다. 입력값은 그대로 유지됩니다.";
            await this.service.render();
            return;
        }
        this.saving = false;
        if (response.code !== 200) {
            this.errorMessage = response.code === 409
                ? this.responseMessage(response, "다른 사용자가 먼저 저장했습니다. 입력값은 유지되며 새로고침 후 다시 비교해주세요.")
                : this.responseMessage(response, "자료 상세 편집 정보를 저장하지 못했습니다. 입력값은 그대로 유지됩니다.");
            await this.service.render();
            return;
        }
        this.message = response.data?.message || "자료 상세 편집 정보가 저장되었습니다.";
        await this.loadDetail();
    }

    public requiredMissing(): string[] {
        let missing: string[] = [];
        if (!this.text(this.form.title)) missing.push("제목");
        if (!this.text(this.form.materialType)) missing.push("자료 유형");
        if (!this.text(this.form.publicStatus)) missing.push("공개 상태");
        if (!this.text(this.form.reviewStatus)) missing.push("검수 상태");
        return missing;
    }

    public responseMessage(response: any, fallback: string): string {
        let data = response?.data;
        if (typeof data === "string") return data;
        if (data?.message) return data.message;
        return fallback;
    }

    public text(value: any): string {
        if (value === null || value === undefined) return "";
        return `${value}`.trim();
    }

    public currentUserName(): string {
        return this.service.auth.session?.name || this.service.auth.session?.username || "";
    }

    public isAdmin(): boolean {
        return this.service.auth.session?.status === "active" && this.service.auth.session?.role === "admin";
    }

    public materialPermissions(): string[] {
        let value = this.service.auth.session?.materialsPermissions || this.service.auth.session?.materials_permissions || [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim()) {
            try {
                let parsed = JSON.parse(value);
                if (Array.isArray(parsed)) return parsed;
            } catch (e) {
                return value.split(",").map((item) => item.trim()).filter((item) => !!item);
            }
        }
        return [];
    }

    public canAccessMaterials(): boolean {
        let session = this.service.auth.session || {};
        return session.status === "active" && (["admin", "materials"].includes(session.role) || this.materialPermissions().length > 0);
    }

    public canEditMaterials(): boolean {
        let session = this.service.auth.session || {};
        let permissions = this.materialPermissions();
        return session.status === "active" && (
            session.role === "admin" ||
            session.role === "materials" ||
            permissions.includes("materials_admin") ||
            permissions.includes("materials_review")
        );
    }

    public canApprovePublication(): boolean {
        let session = this.service.auth.session || {};
        let permissions = this.materialPermissions();
        return session.status === "active" && (
            session.role === "admin" ||
            permissions.includes("materials_admin") ||
            permissions.includes("materials_approve")
        );
    }

    public canSaveChanges(): boolean {
        return this.canEditMaterials() || this.canApprovePublication();
    }

    public async selectGraphRelation(relation: any) {
        this.selectedGraphRelation = relation || null;
        this.resetRelationForm();
        this.errorMessage = "";
        this.message = "";
        await this.service.render();
    }

    private resetRelationForm() {
        this.relationForm = {
            relationType: this.text(this.selectedGraphRelation?.type),
            reviewStatus: this.text(this.selectedGraphRelation?.reviewStatus) || "검수 대기",
            reviewNote: this.text(this.selectedGraphRelation?.reviewNote),
            swapDirection: false,
        };
    }

    public relationDirectionLabel(relation: any = this.selectedGraphRelation): string {
        if (!relation) return "관계 미선택";
        let source = this.text(relation.sourceLabel) || "주체 미확인";
        let target = this.text(relation.targetLabel) || "대상 미확인";
        return this.relationForm.swapDirection ? `${target} → ${source}` : `${source} → ${target}`;
    }

    public relationEvidenceLocation(relation: any): string {
        if (!relation) return "근거 미확인";
        let pdfPage = Number(relation.pdfPage || relation.page || 0);
        return `자료 ${relation.materialId || "미확인"} · 파일 ${relation.fileId || "미확인"} · PDF ${pdfPage || "미확인"}쪽 · 인쇄쪽수 ${relation.printedPage || "미확인"} · ${relation.chunkId || "청크 미확인"}`;
    }

    public selectedRelationHistory(): any[] {
        if (!this.selectedGraphRelation) return [];
        return (this.sections?.graph?.history || []).filter((row: any) => row.relationId === this.selectedGraphRelation.id).slice(0, 5);
    }

    private newRelationRequestId(): string {
        return `relation-${this.materialId}-${this.selectedGraphRelation?.id || "unknown"}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }

    public async saveGraphRelation() {
        if (!this.selectedGraphRelation || !this.canEditMaterials() || this.relationSaving) return;
        this.errorMessage = "";
        this.message = "";
        if (["검수 완료", "보류", "수정 후보", "반려"].includes(this.relationForm.reviewStatus) && !this.text(this.relationForm.reviewNote)) {
            this.errorMessage = "관계 확인 상태의 근거 또는 수정 사유를 입력해주세요.";
            await this.service.render();
            return;
        }
        this.relationSaving = true;
        await this.service.render();
        let relation = this.selectedGraphRelation;
        let sourceNodeId = this.relationForm.swapDirection ? relation.target : relation.source;
        let targetNodeId = this.relationForm.swapDirection ? relation.source : relation.target;
        let response: any;
        try {
            response = await wiz.call("save_graph_relation", {
                payload: JSON.stringify({
                    materialId: this.materialId,
                    relationId: relation.id,
                    graphVersion: this.sections?.graph?.graphVersion,
                    relationType: this.relationForm.relationType,
                    reviewStatus: this.relationForm.reviewStatus,
                    reviewNote: this.relationForm.reviewNote,
                    sourceNodeId,
                    targetNodeId,
                    requestId: this.newRelationRequestId(),
                })
            });
        } catch (e) {
            this.relationSaving = false;
            this.errorMessage = "관계 저장에 실패했습니다. 최신 관계를 다시 확인해주세요.";
            await this.service.render();
            return;
        }
        this.relationSaving = false;
        if (response.code !== 200) {
            this.errorMessage = this.responseMessage(response, "관계 저장에 실패했습니다.");
            await this.service.render();
            return;
        }
        let relationId = relation.id;
        await this.loadDetail();
        this.selectedGraphRelation = (this.sections?.graph?.relations || []).find((row: any) => row.id === relationId) || null;
        if (this.selectedGraphRelation) this.resetRelationForm();
        this.message = response.data?.message || "관계 수정과 이력을 저장했습니다.";
        await this.service.render();
    }

    public async setTab(tab: string, event?: Event, updateHistory: boolean = true) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.tabs.some((item) => item.key === tab)) return;
        this.activeTab = tab;
        this.routeNotice = "";
        if (updateHistory) this.syncTabUrl("push");
        await this.service.render();
    }

    public async handleTabKeydown(event: KeyboardEvent, index: number) {
        let targetIndex = index;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") targetIndex = (index + 1) % this.tabs.length;
        else if (event.key === "ArrowLeft" || event.key === "ArrowUp") targetIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === "Home") targetIndex = 0;
        else if (event.key === "End") targetIndex = this.tabs.length - 1;
        else return;
        event.preventDefault();
        await this.setTab(this.tabs[targetIndex].key, undefined, true);
        setTimeout(() => document.getElementById(this.tabButtonId(this.tabs[targetIndex].key))?.focus(), 0);
    }

    public tabButtonId(tab: string): string {
        return `material-tab-${tab}`;
    }

    public tabPanelId(tab: string): string {
        return `material-panel-${tab}`;
    }

    private restoreTabFromUrl(replaceInvalid: boolean = false) {
        let params = new URLSearchParams(window.location.search || "");
        let requested = this.text(params.get("tab"));
        if (!requested && window.location.hash) requested = this.text(window.location.hash.replace(/^#/, ""));
        if (!requested) requested = "bibliography";
        let aliases: any = {
            review: "review", check: "review",
            basic: "bibliography", bibliography: "bibliography",
            original: "original", source: "original",
            metadata: "metadata",
            body: "chunks", chunks: "chunks",
            graph: "graph", relations: "graph",
            history: "history",
        };
        let normalized = aliases[requested] || requested;
        if (!this.tabs.some((item) => item.key === normalized)) {
            this.activeTab = "bibliography";
            this.routeNotice = `지원하지 않는 상세 탭(${requested}) 대신 기본정보를 표시합니다.`;
            if (replaceInvalid) this.syncTabUrl("replace");
            return;
        }
        this.activeTab = normalized;
        if (replaceInvalid || normalized !== requested) this.syncTabUrl("replace");
    }

    private syncTabUrl(mode: "push" | "replace") {
        let url = new URL(window.location.href);
        url.searchParams.set("tab", this.activeTab);
        url.hash = "";
        let target = `${url.pathname}${url.search}`;
        if (`${window.location.pathname}${window.location.search}` === target) return;
        if (mode === "push") window.history.pushState({ tab: this.activeTab }, "", target);
        else window.history.replaceState({ tab: this.activeTab }, "", target);
    }

    private formSnapshot(): string {
        return JSON.stringify(this.form || {});
    }

    private markFormClean() {
        this.cleanForm = { ...this.form, changeNote: "" };
        this.form.changeNote = "";
        this.cleanFormSnapshot = this.formSnapshot();
    }

    public hasUnsavedChanges(): boolean {
        return !!this.material && !this.saving && !!this.cleanFormSnapshot && this.formSnapshot() !== this.cleanFormSnapshot;
    }

    public changedFields(): any {
        let changes: any = {};
        let fields = ([] as string[]).concat(
            (this.savePolicy?.immediateFields || []).map((item: any) => item.field),
            (this.savePolicy?.reviewPendingFields || []).map((item: any) => item.field),
        );
        fields.forEach((field: string) => {
            let current = this.text((this.form as any)[field]);
            let previous = this.text((this.cleanForm as any)[field]);
            if (current !== previous) changes[field] = current;
        });
        return changes;
    }

    public hasChangedFields(): boolean {
        return Object.keys(this.changedFields()).length > 0;
    }

    public async cancelChanges() {
        this.form = { ...this.cleanForm, changeNote: "" };
        this.errorMessage = "";
        this.message = "저장하지 않은 변경을 마지막 서버 저장값으로 되돌렸습니다.";
        this.markFormClean();
        await this.service.render();
    }

    public async applyCandidate(field: string, value: any) {
        if (!this.canEditMaterials() || !field || !this.text(value)) return;
        (this.form as any)[field] = this.text(value);
        this.message = "자동 후보를 입력란에 반영했습니다. 저장 전까지 확정값은 바뀌지 않습니다.";
        this.errorMessage = "";
        await this.service.render();
    }

    public async addCandidateKeyword(value: any) {
        if (!this.canEditMaterials() || !this.text(value)) return;
        let items = this.text(this.form.subjectKeywords).split(/[\n,]/).map((item) => this.text(item)).filter((item) => !!item);
        if (!items.includes(this.text(value))) items.push(this.text(value));
        this.form.subjectKeywords = items.join("\n");
        this.message = "자동 주제어 후보를 입력란에 추가했습니다. 저장해야 반영됩니다.";
        await this.service.render();
    }

    public reviewTasks(): any[] {
        return this.sections?.review?.tasks || [];
    }

    public selectedReviewTask(): any {
        let tasks = this.reviewTasks();
        return tasks.find((item: any) => item.reasonKey === this.selectedReviewReason) || tasks[0] || null;
    }

    public activeReviewTasks(): any[] {
        return this.reviewTasks().filter((item: any) => item.active);
    }

    private restoreReviewReasonFromUrl() {
        let requested = this.text(new URLSearchParams(window.location.search || "").get("reason"));
        let tasks = this.reviewTasks();
        let active = tasks.filter((item: any) => item.active);
        let selected = tasks.find((item: any) => item.reasonKey === requested);
        this.selectedReviewReason = selected?.reasonKey || active[0]?.reasonKey || tasks[0]?.reasonKey || "";
        if (requested && !selected) this.routeNotice = `현재 자료에 없는 확인 사유(${requested}) 대신 사용 가능한 사유를 표시합니다.`;
        if (this.selectedReviewReason) {
            let url = new URL(window.location.href);
            if (url.searchParams.get("reason") !== this.selectedReviewReason) {
                url.searchParams.set("reason", this.selectedReviewReason);
                window.history.replaceState({ tab: this.activeTab, reason: this.selectedReviewReason }, "", `${url.pathname}${url.search}`);
            }
        }
    }

    private resetReviewForm() {
        let task = this.selectedReviewTask();
        this.reviewForm = {
            note: "",
            targetPublicStatus: this.text(task?.evidence?.currentPublicStatus || this.form.publicStatus),
            confirmations: {},
        };
        this.reviewRequestId = "";
    }

    public async selectReviewReason(reasonKey: string) {
        if (!this.reviewTasks().some((item: any) => item.reasonKey === reasonKey)) return;
        this.selectedReviewReason = reasonKey;
        this.activeTab = "review";
        this.resetReviewForm();
        let url = new URL(window.location.href);
        url.searchParams.set("tab", "review");
        url.searchParams.set("reason", reasonKey);
        window.history.pushState({ tab: "review", reason: reasonKey }, "", `${url.pathname}${url.search}`);
        await this.service.render();
    }

    public humanReviewChecks(): any[] {
        return (this.selectedReviewTask()?.checklist || []).filter((item: any) => item.kind === "human");
    }

    public automaticReviewChecks(): any[] {
        return (this.selectedReviewTask()?.checklist || []).filter((item: any) => item.kind === "automatic");
    }

    public reviewOriginalContextUrl(): string {
        let url = new URL(window.location.href);
        url.searchParams.set("tab", "original");
        if (this.selectedReviewReason) url.searchParams.set("reason", this.selectedReviewReason);
        return `${url.pathname}${url.search}`;
    }

    public canApplyReviewAction(action: string): boolean {
        let task = this.selectedReviewTask();
        if (!task || this.reviewSaving) return false;
        if (!task.active && task.status !== "completed") return false;
        if (Array.isArray(task.allowedActionKeys) && !task.allowedActionKeys.includes(action)) return false;
        if (task.reasonKey === "public_scope" && action === "completed") return this.canApprovePublication();
        return this.canEditMaterials();
    }

    private newReviewRequestId(action: string): string {
        let random = Math.random().toString(36).slice(2, 10);
        return `review-${this.materialId}-${this.selectedReviewReason}-${action}-${Date.now()}-${random}`;
    }

    public async applyReviewAction(action: string) {
        if (!this.canApplyReviewAction(action)) return;
        let task = this.selectedReviewTask();
        this.errorMessage = "";
        this.message = "";
        if (!this.text(this.reviewForm.note)) {
            this.errorMessage = "확인 의견을 입력해주세요.";
            await this.service.render();
            return;
        }
        if (!this.reviewRequestId) this.reviewRequestId = this.newReviewRequestId(action);
        this.reviewSaving = true;
        await this.service.render();
        let response: any;
        try {
            response = await wiz.call("review_action", {
                payload: JSON.stringify({
                    materialId: this.materialId,
                    reasonKey: task.reasonKey,
                    action,
                    baseVersion: this.baseVersion,
                    reasonFingerprint: task.fingerprint,
                    note: this.reviewForm.note,
                    confirmations: this.reviewForm.confirmations || {},
                    currentPublicStatus: task.evidence?.currentPublicStatus || this.form.publicStatus,
                    targetPublicStatus: this.reviewForm.targetPublicStatus || this.form.publicStatus,
                    requestId: this.reviewRequestId,
                })
            });
        } catch (e) {
            this.reviewSaving = false;
            let error: any = e as any;
            let code = Number(error?.code || error?.status || error?.response?.status || 0);
            let serialized = "";
            try { serialized = JSON.stringify(error || {}); } catch (ignore) { }
            this.errorMessage = code === 409 || serialized.includes("409")
                ? "자료 또는 확인 근거가 변경되었습니다. 입력한 의견은 유지되며 최신 내용을 다시 확인해주세요."
                : "상태 변경에 실패했습니다. 입력한 의견과 확인 항목은 유지됩니다.";
            await this.service.render();
            return;
        }
        this.reviewSaving = false;
        if (response.code !== 200) {
            this.errorMessage = this.responseMessage(response, "사유별 확인 상태를 변경하지 못했습니다.");
            await this.service.render();
            return;
        }
        let savedMessage = response.data?.message || "사유별 확인 상태를 기록했습니다.";
        this.reviewRequestId = "";
        await this.loadDetail();
        this.message = savedMessage;
        await this.service.render();
    }

    public listReturnUrl(): string {
        let requested = new URLSearchParams(window.location.search || "").get("returnTo") || "/admin/materials?view=list";
        try {
            let parsed = new URL(requested, window.location.origin);
            if (parsed.origin === window.location.origin && parsed.pathname === "/admin/materials") {
                return `${parsed.pathname}${parsed.search}`;
            }
        } catch (e) { }
        return "/admin/materials?view=list";
    }

    @HostListener('window:popstate')
    public async handlePopState() {
        this.restoreTabFromUrl(true);
        this.restoreReviewReasonFromUrl();
        this.resetReviewForm();
        await this.service.render();
    }

    @HostListener('window:beforeunload', ['$event'])
    public handleBeforeUnload(event: BeforeUnloadEvent) {
        if (!this.hasUnsavedChanges()) return;
        event.preventDefault();
        event.returnValue = "";
    }

    public displayTerm(value: any): string {
        let text = value === null || value === undefined ? "" : `${value}`;
        const exact: any = {
            "내부열람": "내부 사용자만 열람",
            "검수 대기": "자료 확인 필요",
            "검수대기": "자료 확인 필요",
            "검수 완료": "자료 확인 완료",
            "검수완료": "자료 확인 완료",
            "태그추천대기": "주제어 확인 필요",
            "본문근거연결대기": "본문 근거 연결 확인 필요",
            "OCR 필요": "이미지 속 글자 인식 필요"
        };
        if (exact[text]) return exact[text];
        return text
            .replace(/서지DB/g, "자료 기본정보")
            .replace(/원문DB/g, "원문 파일")
            .replace(/메타데이터/g, "자료 정보")
            .replace(/본문색인/g, "본문 검색")
            .replace(/청크/g, "본문 구간")
            .replace(/지식그래프/g, "자료 관계도")
            .replace(/노드/g, "항목")
            .replace(/태그/g, "주제어")
            .replace(/검수/g, "자료 확인")
            .replace(/내부열람/g, "내부 사용자만 열람")
            .replace(/OCR/g, "이미지 속 글자 인식");
    }

    public statusClass(value: string): string {
        let text = (value || "").replace(/\s+/g, "");
        if (text === "공개") return "is-public";
        if (text === "내부열람") return "is-internal";
        if (text === "공개보류") return "is-hold";
        if (text === "비공개") return "is-private";
        if (text === "검수대기") return "is-review-pending";
        if (text === "검수완료") return "is-review-complete";
        if (text === "등록초안") return "is-draft";
        if (text.includes("보류") || text.includes("보완") || text.includes("필요") || text.includes("미보유") || text.includes("반려")) return "is-hold";
        if (text.includes("실패")) return "is-private";
        if (text.includes("미확인")) return "is-muted";
        if (text.includes("대기") || text.includes("요청")) return "is-review-pending";
        if (text.includes("완료") || text.includes("확보") || text.includes("연결") || text.includes("색인")) return "is-complete";
        if (text.includes("내부")) return "is-internal";
        return "is-muted";
    }

    public sourceClass(source: string): string {
        if ((source || "").includes("AI")) return "is-ai";
        if ((source || "").includes("확정")) return "is-confirmed";
        return "is-source";
    }

    public formValue(field: DetailField): string {
        if (!field?.field) return this.text(field?.value);
        return this.text((this.form as any)[field.field]);
    }

    public isLongField(field: string): boolean {
        return ["contributor", "subjectKeywords", "summary", "source"].includes(field);
    }

    public trackTab(index: number, item: any) {
        return item.key || index;
    }

    public trackField(index: number, item: DetailField) {
        return item.label || index;
    }

    public trackItem(index: number, item: any) {
        return item.id || item.chunkId || item.fileId || item.label || item.name || index;
    }
}

export default PageAdminMaterialsDetailComponent;